import styled from "styled-components";
import { Button } from "@interstate/components/Button";

const TogglesContainer = styled.div`
  display: flex;
  gap: 8px;
`;

const StyledButton = styled(Button)<{ $isActive: boolean }>`
  padding: 6px 12px;
  font-size: 12px !important;
  font-weight: normal !important;
  min-height: 32px;
  width: 43px;
  background-color: ${props =>
    props.$isActive ? "#0073e6" : "#ededed"} !important;
  border: 1px solid #d0d0d0 !important;
  color: ${props => (props.$isActive ? "#ffffff" : "#000000")} !important;
  transition: background-color 0.2s ease, color 0.2s ease;

  &:hover:not(:disabled) {
    background-color: #0073e6 !important;
    color: #ffffff !important;
  }
`;

export interface CcBccTogglesProps {
  showCc: boolean;
  showBcc: boolean;
  onToggleCc: () => void;
  onToggleBcc: () => void;
  disabled?: boolean;
}

export function CcBccToggles({
  showCc,
  showBcc,
  onToggleCc,
  onToggleBcc,
  disabled = false
}: CcBccTogglesProps) {
  return (
    <TogglesContainer>
      <span title="Carbon Copy">
        <StyledButton
          $isActive={showCc}
          aria-label={showCc ? "Hide CC field" : "Show CC field"}
          aria-pressed={showCc}
          data-testid="cc-toggle-button"
          disabled={disabled}
          onClick={onToggleCc}
        >
          CC
        </StyledButton>
      </span>
      <span title="Blind Carbon Copy">
        <StyledButton
          $isActive={showBcc}
          aria-label={showBcc ? "Hide BCC field" : "Show BCC field"}
          aria-pressed={showBcc}
          data-testid="bcc-toggle-button"
          disabled={disabled}
          onClick={onToggleBcc}
        >
          BCC
        </StyledButton>
      </span>
    </TogglesContainer>
  );
}

export default CcBccToggles;
